import { render, staticRenderFns } from "./DragUploadCmp.vue?vue&type=template&id=0afb3e32&scoped=true"
import script from "./DragUploadCmp.vue?vue&type=script&lang=js"
export * from "./DragUploadCmp.vue?vue&type=script&lang=js"
import style0 from "./DragUploadCmp.vue?vue&type=style&index=0&id=0afb3e32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb3e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afb3e32')) {
      api.createRecord('0afb3e32', component.options)
    } else {
      api.reload('0afb3e32', component.options)
    }
    module.hot.accept("./DragUploadCmp.vue?vue&type=template&id=0afb3e32&scoped=true", function () {
      api.rerender('0afb3e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/fundManagement/customerRechargeDetails/components/DragUploadCmp.vue"
export default component.exports